import { ControlBreadcrumbLink, ListBreadCrumbs } from 'elements/BreadCrumbs'
import { StructType } from './hooks/useStructTypes'

type StructsBreadcrumbsProps = {
  currentType?: StructType | undefined
  currentTypeId?: string
  mode: 'create' | 'edit' | 'list'
}

export const StructsBreadcrumbs = ({ currentType, currentTypeId, mode }: StructsBreadcrumbsProps) => {
  const breadcrumbs = [ControlBreadcrumbLink]
  const isSingularList = currentTypeId === 'singular'
  const isSingularType = currentType?.singular === true

  if (isSingularList) {
    breadcrumbs.push({ title: 'Single Configs', link: '/structs/singular' })
    if (mode === 'create' && currentType) {
      breadcrumbs.push({ title: 'Create ' + currentType.title, link: '' })
    } else if (mode === 'edit' && currentType) {
      breadcrumbs.push({ title: 'Edit ' + currentType.title, link: '' })
    }
  } else if (currentType) {
    if (isSingularType) {
      breadcrumbs.push({ title: 'Single Configs', link: '/structs/singular' })
    } else {
      breadcrumbs.push({ title: currentType.title, link: `/structs/${currentType.id}` })
    }

    switch (mode) {
      case 'create':
        breadcrumbs.push({ title: 'Create ' + currentType.title, link: '' })
        break
      case 'edit':
        breadcrumbs.push({ title: 'Edit ' + currentType.title, link: '' })
        break
    }
  }

  return <ListBreadCrumbs links={breadcrumbs} />
}
